import styled from 'styled-components';

export const BORDER_RADIUS = '6px';

export const Card = styled.div`
  border-radius: 6px;
  box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.08);
`;

export default {};
